export default {
  // Hero
  bizHeroTag: "Investment Opportunities",
  bizHeroTitle1: "Investment &",
  bizHeroTitle2: "Business Opportunities",
  bizHeroDesc: "From company incorporation to curated investment opportunities across East Africa — AIP connects you to the right markets, institutions, and partners to grow your business.",
  bizCtaRegister: "Register a Company",
  bizCtaExplore: "Explore Opportunities",
  bizStat1: "Companies Registered",
  bizStat2: "Markets Covered",
  bizStat3: "Days to Incorporate",
  bizStat4: "Success Rate",
  bizCardTitle: "Company Registration",
  bizCardSubtitle: "Rwanda & East Africa",
  bizCard1: "Rwanda Development Board filing",
  bizCard2: "Tax registration (TIN)",
  bizCard3: "Business license & permits",
  bizCard4: "Bank account setup",
  bizOppTitle: "Live Opportunity",
  bizOppName: "Pharmaceutical Hub – Kigali",
  bizCountriesTitle: "Operating Across",

  // Opportunities
  oppTag: "Section B",
  oppTitle1: "Investment",
  oppTitle2: "Opportunities",
  oppDesc: "Curated investment and partnership opportunities across East Africa. Browse active deals and express interest in minutes.",
  oppFilterCountry: "All Countries",
  oppFilterSector: "All Sectors",
  oppClear: "Clear filters",
  oppCount_one: "opportunity found",
  oppCount_other: "opportunities found",
  oppNoResults: "No opportunities match your filters",
  oppNoResultsHint: "Try adjusting your country or sector selection",
  oppViewDetails: "View Details",
  oppInvestment: "Investment",

  // Registration
  regTag: "Section A",
  regTitle1: "Company",
  regTitle2: "Registration",
  regDesc: "Fast, hassle-free incorporation across Rwanda and East Africa. We handle everything from paperwork to approval.",
  regRwandaNote: "Rwanda: as fast as 3 days",
  regDays: "days",
  regHowItWorks: "How It Works",
  regStep1Title: "Document Prep",
  regStep1Desc: "We collect and verify all required incorporation documents.",
  regStep2Title: "Name Reservation",
  regStep2Desc: "Reserve your unique company name with the relevant authority.",
  regStep3Title: "Filing & Approval",
  regStep3Desc: "We submit your application and manage communication with regulators.",
  regStep4Title: "Certificate Issued",
  regStep4Desc: "Receive your Certificate of Incorporation and start trading.",
  regFormTitle: "Start Your Registration",
  regFormName: "Full Name",
  regFormEmail: "Email Address",
  regFormCountry: "Country of Registration",
  regFormSector: "Industry Sector",
  regFormActivity: "Business Activity",
  regFormSubmit: "Start Now",
  regFormConfidential: "We respond within 24 hours. Your information is confidential.",
  regFormSuccessTitle: "Application Received!",
  regFormSuccessBody: "Our team will reach out within 24 hours to guide your next steps.",
  regWhyRwanda: "Why Rwanda?",
  regRwandaStat1: "Avg. Registration",
  regRwandaStat2: "Min. Capital",
  regRwandaStat3: "Foreign Ownership",
  regRwandaDesc: "Rwanda ranks #2 in Africa for ease of doing business. 100% foreign ownership, no minimum capital requirement, and digital-first registration make it the top entry point for East Africa.",

  // Investment Portals
  portalTag: "Official Investment Portals",
  portalTitle1: "Invest by",
  portalTitle2: "Country",
  portalDesc: "Each country has a dedicated investment authority to guide you through regulations, incentives, and opportunities. Below are the official portals AIP works with across the region.",
  portalCount: "7 countries · official portals",
  portalNeedGuidance: "Need guidance navigating these portals?",
  portalGuidanceDesc: "AIP handles the end-to-end process — from investment registration to regulatory approvals across all 7 countries.",
  portalTalkTeam: "Talk to Our Team",
  portalVisit: "Visit",
  portalPortal: "Portal",
};